@import "~@uipath/apollo-core/src/scss/base-host.scss";
@import "../../utils/mixins/mixins.scss";
@import url("https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined");

:host {
  font-family: $font-normal;
  font-size: $font-m-size;
  line-height: $font-m-line-height;
  .portal-dropdown {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: solid 1px var(--color-foreground-de-emp);
    background-color: var(--color-background);
    color: var(--color-foreground);
    border-radius: $border-radius-s;
    line-height: $font-micro-line-height;
    height: 32px;
    padding: $pad-m $pad-m $pad-m $pad-xl;
    box-sizing: border-box;
    transition: all ease-in-out 200ms;

    &::after {
      @include after-background-effect();
      user-select: none;
      border-radius: $border-radius-s;
    }

    &.disabled {
      pointer-events: none;
      border-color: var(--color-border-disabled);
      color: var(--color-foreground-disable);
    }

    &:active {
      &::after {
        background-color: var(--color-hover);
        border-color: var(--color-primary);
        box-shadow: 0 0 0 1px var(--color-primary) inset;
      }
    }
    &.dp-focused:not(:active),
    &:hover:not(:active) {
      &::after {
        background-color: var(--color-icon-default);
        opacity: 0.12;
        border-color: var(--color-foreground-de-emp);
      }
    }

    &.dp-focused.from-keyboard:not(:active):not(.dropdown-open) {
      outline: auto;
      opacity: 1;
    }

    &.dp-focused input {
      left: 0;
      top: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      border: none;
      background-color: transparent;
      outline: none;
    }

    &.dropdown-open {
      .dropdown-trigger {
        transform: rotate(-180deg);
      }
      .dropdown-list {
        padding: 4px 0px;
        visibility: visible;
        opacity: 1;
        transform: translateY(0px) scaleY(1);
      }
    }

    .dropdown-list {
      box-sizing: border-box;
      visibility: hidden;
      position: absolute;
      opacity: 0;
      top: 100%;
      left: 0;
      z-index: 999;
      min-width: 100%;
      max-width: 500px;
      overflow-y: auto;
      transition: all ease 100ms;
      transform: translateY(-15px) scaleY(0.7);
      transform-origin: center top;
      background-color: var(--color-background-raised);
      color: var(--color-foreground-de-emp);
      border: 0 none;
      border-radius: $border-radius-s;
      box-shadow: $shadow-menu-elevation;
      ul {
        list-style: none;
        margin: 0;
        padding: 0;
        li {
          padding: 0 $pad-xxxl;
          height: 32px;
          display: flex;
          align-items: center;
          &:hover,
          &.option-focused {
            background-color: var(--color-hover);
            cursor: var(--cursor);
          }
          &.option-selected {
            box-shadow: inset 4px 0px 0px var(--color-foreground-highlight);
            background-color: var(--color-foreground-highlight-selected);
            cursor: var(--cursor);
          }
          &.disabled {
            pointer-events: none;
            user-select: none;
            cursor: default;
            color: var(--color-foreground-disable);
          }
        }
      }
      .option-icon {
        margin-right: 10px;
      }
      .canary-chip {
        margin-left: 4px;
        margin-top: 2px;
      }
      .option-label {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: $pad-m 0;
      }
    }

    .dropdown-text {
      width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      padding: $pad-xl 0;
    }
    .prefix {
      margin-right: 8px;
    }
  }
  .p-hidden-accessible {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
    input {
      transform: scale(0);
    }
  }
  .dropdown-trigger {
    height: 28px;
    display: flex;
    align-items: center;
    transition: ease 200ms;
    margin-left: $pad-s;
    margin-top: $pad-xs;
    color: var(--color-foreground-de-emp);
  }
}
